import * as Types from '../types-api.generated';

import { MediaFragment, EditionSaleConfigurationFragment, DropSaleConfigurationFragment } from '../api-fragments.generated';
import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { apiFetcher } from 'lib/clients/graphql';

import { ClientError } from "graphql-request";
import { Address } from "viem";
import { ChainId } from "lib/chains";

export type ApiWorldSoldNftsVariables = Types.Exact<{
  id: Types.Scalars['Int'];
  page?: Types.InputMaybe<Types.Scalars['Int']>;
  perPage?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type ApiWorldSoldNfts = { worldSoldNfts: { totalItems: number, totalPages: number, page: number, items: Array<{ chainId: ChainId, name: string | null, id: string, tokenId: number, contractAddress: Address, sale: { amount: number, date: string }, media: { __typename: 'ImageMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, imageMimeType: Types.ApiImageMimeType } | { __typename: 'ModelMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, modelMimeType: Types.ApiModelMimeType, modelStaticUrl: string } | { __typename: 'VideoMedia', previewUrl: string | null, processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, staticUrl: string | null, url: string, videoMimeType: Types.ApiVideoMimeType } | null, creator: { profileImageUrl: string | null, username: string | null, name: string | null, publicKey: Address } }> } };



export const ApiWorldSoldNftsDocument = /*#__PURE__*/ `
    query WorldSoldNfts($id: Int!, $page: Int, $perPage: Int) {
  worldSoldNfts: exhibitionSoldNfts(
    exhibitionId: $id
    page: $page
    perPage: $perPage
  ) {
    items {
      chainId
      name
      id
      tokenId
      contractAddress
      sale {
        amount
        date
      }
      media {
        ...MediaFragment
      }
      creator {
        profileImageUrl
        publicKey: accountAddress
        username
        name
      }
    }
    totalItems
    totalPages
    page
  }
}
    ${MediaFragment}`;

export const useWorldSoldNfts = <
      TData = ApiWorldSoldNfts,
      TError = ClientError
    >(
      variables: ApiWorldSoldNftsVariables,
      options?: Omit<UseQueryOptions<ApiWorldSoldNfts, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ApiWorldSoldNfts, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ApiWorldSoldNfts, TError, TData>(
      {
    queryKey: ['WorldSoldNfts', variables],
    queryFn: apiFetcher<ApiWorldSoldNfts, ApiWorldSoldNftsVariables>(ApiWorldSoldNftsDocument, variables),
    ...options
  }
    )};

useWorldSoldNfts.getKey = (variables: ApiWorldSoldNftsVariables) => ['WorldSoldNfts', variables];

export const useInfiniteWorldSoldNfts = <
      TData = InfiniteData<ApiWorldSoldNfts>,
      TError = ClientError
    >(
      variables: ApiWorldSoldNftsVariables,
      options: Omit<UseInfiniteQueryOptions<ApiWorldSoldNfts, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ApiWorldSoldNfts, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ApiWorldSoldNfts, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['WorldSoldNfts.infinite', variables],
      queryFn: (metaData) => apiFetcher<ApiWorldSoldNfts, ApiWorldSoldNftsVariables>(ApiWorldSoldNftsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteWorldSoldNfts.getKey = (variables: ApiWorldSoldNftsVariables) => ['WorldSoldNfts.infinite', variables];


useWorldSoldNfts.fetcher = (variables: ApiWorldSoldNftsVariables, options?: RequestInit['headers']) => apiFetcher<ApiWorldSoldNfts, ApiWorldSoldNftsVariables>(ApiWorldSoldNftsDocument, variables, options);
